import { render } from "./LinkName.vue?vue&type=template&id=6d69a3fa"
import script from "./LinkName.vue?vue&type=script&lang=js"
export * from "./LinkName.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__